const TRANSLATE_DIR = 'translations';

export const TRANSLATIONS_MAP = {
    ru: () => import(`./${TRANSLATE_DIR}/ru`),
    en: () => import(`./${TRANSLATE_DIR}/en`),
    fr: () => import(`./${TRANSLATE_DIR}/fr`),
    pt: () => import(`./${TRANSLATE_DIR}/pt`),
    ar: () => import(`./${TRANSLATE_DIR}/ar`),
    es: () => import(`./${TRANSLATE_DIR}/es-la`),
} as const;

export type Language = keyof typeof TRANSLATIONS_MAP;
export const allLanguages = Object.keys(TRANSLATIONS_MAP) as Language[];
